export default __webpack_public_path__ + "static/media/151-maps-and-flags-4.d183dcdb.png";